import classes from "./DeleteVehicle.module.css";
import ModalWrapper from "../../modalWrapper/ModalWrapper";
import { ActionBtn } from "../../buttons/actionBtn/ActionBtn";
import { deleteVehicle } from "../../../redux/vehicle/deleteVehicle";
import { LoadingSpinner } from "../../loadingSpinner/LoadingSpinner";
import { useTranslations } from "../../../helperFunctions/customHooks/useTranslations";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsDeleteVehicleShown,
  setSelectedDataForEdit,
} from "../../../redux/globalFunctions/globalFnSlice";

export function DeleteVehicle() {
  const dispatch = useDispatch();
  const { t } = useTranslations();
  const { status } = useSelector((state) => state.deleteVehicle);
  const { selectedDataForEdit } = useSelector((state) => state.global);

  function handleCloseModal() {
    dispatch(setSelectedDataForEdit(null));
    dispatch(setIsDeleteVehicleShown(false));
  }

  function handleDeleteClick() {
    dispatch(deleteVehicle({ id: selectedDataForEdit.v_id }));
  }

  return (
    <ModalWrapper
      title={t.deleteModal.deleteVehicle.title}
      width={"500px"}
      onClick={handleCloseModal}
    >
      <div className={classes.content}>
        <p>
          {t.deleteModal.deleteConfirmationText}{" "}
          <span>{selectedDataForEdit.v_name}</span>?
        </p>
        <p>{t.deleteModal.deleteVehicle.text}</p>
        <div className={classes.buttons}>
          <ActionBtn
            onClick={handleCloseModal}
            btnType="cancel"
            text={t.deleteModal.cancel}
          />
          <ActionBtn
            width={"100%"}
            height={"42px"}
            text={
              status === "loading" ? <LoadingSpinner /> : t.deleteModal.delete
            }
            onClick={handleDeleteClick}
          />
        </div>
      </div>
    </ModalWrapper>
  );
}
